export default __webpack_public_path__ + "static/media/Vambraces of the Tormentor.71401c27.jpg";